/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

var getParams = function getParams(params, queryParams) {
  var setParams = params.split(','); // Split all of the params by commas
  var availableQueryParams = queryParams.split(','); // split all of the possible params by comma
  var splitAndTrim = function splitAndTrim(param) {
    return param.split(':')[0].trim();
  }; // split the params further by : and remove white space

  return setParams.filter(function (param // Filter out each param that isn't possible for the specific schema
  ) {
    return availableQueryParams.some(function (availableParam) {
      return splitAndTrim(availableParam) === splitAndTrim(param);
    });
  }).join(','); // Rejoin the params into a single string
};

/*
Formats the model, acceptedParams, params, and graphqlQuery into a request body for a graphql server
*/
var generateGQLSchema = (function (_ref) {
  var name = _ref.name,
    schema = _ref.schema,
    params = _ref.params,
    variables = _ref.variables;
  var customSchema = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var modify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  // If the schema is an array of graphql schemas then combine them
  if (Array.isArray(schema)) {
    return "query ".concat(name).concat(variables ? "(".concat(variables, ")") : '', "{\n      ").concat(schema.map(
    // For each schema get the necessary params, name, and schema
    function (_ref2) {
      var _ref2$graphql = _ref2.graphql,
        queryName = _ref2$graphql.name,
        querySchema = _ref2$graphql.schema,
        queryParams = _ref2$graphql.params;
      return "".concat(queryName).concat(params ? "(".concat(getParams(params, queryParams), ")") : '', " ").concat(querySchema);
    }), "\n    }");
  }

  // If the config has a single schema attached then set up a query using the params, variables, name, and schema
  return "".concat(modify ? 'mutation' : 'query').concat(variables ? "(".concat(variables, ")") : '', "{\n    ").concat(name).concat(params ? "(".concat(params, ")") : '', " ").concat(customSchema || schema, "\n  }");
});

export { generateGQLSchema as default };
